<template>
  <div class="general-master">
    <div class="general-master__header">
      <h2 class="general-master__title">詳細</h2>
      <span class="edit__submit-button--small" @click="addLine">追　加</span>
    </div>
    <ul class="general-master__list">
      <li class="general-master__item--header">
        <div></div>
        <div>コード</div>
        <div>名称</div>
        <div></div>
      </li>
      <li class="general-master__item" :draggable="true" @dragstart="dragStart(index)" @dragenter="dragEnter(index)" @dragend.stop.prevent="dragEnd" @dragover.stop.prevent="dragOver" v-bind:key="index" v-for="(generalMaster,index) in data.generalMasterList">
        <div class="general-master__item-icon">
          <i class="fa-solid fa-bars"></i>
        </div>
        <div class="edit__form-input">
          <input type="text" v-model="generalMaster.code" :name="'general_master[list_json]['+index+'][code]'">
        </div>
        <div class="edit__form-input">
          <input type="text" v-model="generalMaster.text" :name="'general_master[list_json]['+index+'][text]'">
        </div>
        <div class="general-master__item-icon">
          <i class="fa-solid fa-times" @click="deleteLine(index)"></i>
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="scss">
.general-master {
  &__header {
    display: flex;
    justify-content: space-between;
  }
  &__title {
    margin: 0;
  }
  &__list {
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  &__item {
    @mixin base() {
      widows: 100%;
      display: grid;
      grid-template-columns: 24px 20% 1fr 24px;
      gap: 10px;
      align-content: center;
    }
    @include base;

    &--header {
      @include base;
      font-weight: bold;
    }
  }
  &__item-icon {
    font-size: 24px;
    height: 35px;
    display: flex;
    align-items: center;
    color: #444;
    cursor: pointer;
  }
}
</style>

<script setup>
import { reactive, onMounted } from "vue";

const data = reactive({
  generalMasterList: [],
  draggingIndex: null,
});

onMounted(() => {
  let $generalMasterListJson = document.getElementById("GeneralMasterListJson");

  if ($generalMasterListJson.value != "") {
    data.generalMasterList = JSON.parse($generalMasterListJson.value);
  } else {
    data.generalMasterList = [
      {
        code: "",
        text: "",
      },
    ];
  }
});

const deleteLine = async function (index) {
  data.generalMasterList = data.generalMasterList.filter((data, i) => {
    return i !== index;
  });
};
const addLine = async function () {
  data.generalMasterList.push({ code: "", text: "" });
};
const dragStart = async function (index, e) {
  data.draggingIndex = index;
};
const dragEnter = async function (index) {
  if (index === data.draggingIndex) return;

  const deleteElement = data.generalMasterList.splice(data.draggingIndex, 1)[0];
  data.generalMasterList.splice(index, 0, deleteElement);
  data.draggingIndex = index;
};
const dragOver = async function (e) {};
const dragEnd = async function (e) {
  data.draggingIndex = null;
};
</script>